export default __webpack_public_path__ + "static/media/ubxt.f11e645f.png";